<app-analytics-risk [hideFilters]="hideFilters" [filters]="filters" [dashboardType]="dashboardType"></app-analytics-risk>